import React, { useEffect, useState } from "react";
import { Modal, ModalHeader, ModalBody, ModalFooter, Button, Form, FormGroup, Label, Input } from "reactstrap";
import axios from "axios";

const EditModal = ({ isOpen, toggle, rowId, columns, apiEndpoint, onSave }) => {
  const [formData, setFormData] = useState({});
  const [loading, setLoading] = useState(false);
  console.log(
    columns
  );
  
  // useEffect(() => {
  //   if (rowId) {
  //     setLoading(true);
  //     axios.get(`${apiEndpoint}/${rowId}`)
  //       .then(response => {
  //         setFormData(response.data);
  //       })
  //       .catch(error => console.error("Error fetching row data:", error))
  //       .finally(() => setLoading(false));
  //   }
  // }, [rowId, apiEndpoint]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prevState => ({
      ...prevState,
      [name]: value
    }));
  };

  const handleSubmit = () => {
    axios.put(`${apiEndpoint}/${rowId}`, formData)
      .then(response => {
        onSave(); // Callback to refresh data
        toggle(); // Close modal
      })
      .catch(error => console.error("Error updating row data:", error));
  };

  return (
    <Modal isOpen={isOpen} toggle={toggle}>
      <ModalHeader toggle={toggle}>Edit Row {rowId}</ModalHeader>
      <ModalBody>
      {loading ? <p>Loading...</p> : (
        <Form>
          <div className="row">
          {columns.map((col, index) => (
              col.field !== 'actions' && (
                <div key={col.field} className="col-md-4"> {/* Divides into 3 columns */}
                  <FormGroup>
                    <Label>{col.label}</Label>
                    <Input 
                      type={col.type.includes("number") ? "number" : "text"} 
                      name={col.field} 
                      value={formData[col.field] || ""} 
                      onChange={handleChange} 
                    />
                  </FormGroup>
                </div>
              )
            ))}
          </div>
        </Form>
      )}
    </ModalBody>
      <ModalFooter>
        <Button color="primary" onClick={handleSubmit}>Save</Button>
        <Button color="secondary" onClick={toggle}>Cancel</Button>
      </ModalFooter>
    </Modal>
  );
};

export default EditModal;
